import TotalStores from './TotalStores'
export default TotalStores
